exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.subscriptions > h5[data-v-fb2015e0]{\n    margin-top: 10px;\n    font-size: 16px;\n    border-bottom: 1px solid #f0f0f0;\n}\n.person-container[data-v-fb2015e0]{\n    padding: 10px 0px;\n    background-color: #fdfdfd;\n    border: 1px solid #dfdfdf;\n    margin-bottom: 20px;\n    border-radius: 5px;\n}\n", ""]);

// exports
